import React from 'react'
import Hero from '../components/Hero'


function TestPage() {
  return (
    <main className='test__page'>
   
      <Hero/>
   
    </main>
  )
}

export default TestPage
